import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';

const TermsOfUsePage = () => {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 py-12 px-4">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Termos de Uso</h1>
          
          <div className="space-y-6 text-gray-600">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Aceitação dos Termos</h2>
              <p>Bem-vindo ao Mapas Astrais. Ao usar nossos serviços, você concorda com os seguintes termos:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Aceitar todas as condições estabelecidas</li>
                <li>Cumprir com as diretrizes de uso</li>
                <li>Respeitar as políticas de privacidade</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Uso do Serviço</h2>
              <p>Nossos serviços devem ser utilizados de acordo com:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>As leis aplicáveis</li>
                <li>As diretrizes da plataforma</li>
                <li>O respeito aos demais usuários</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Privacidade e Dados</h2>
              <p>Seus dados são protegidos conforme:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Nossa política de privacidade</li>
                <li>A Lei Geral de Proteção de Dados</li>
                <li>Padrões internacionais de segurança</li>
              </ul>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/"
              className="text-purple-600 hover:text-purple-700 font-medium"
            >
              ← Voltar para a página inicial
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUsePage;